import { property } from "../data/property";
import Reveal from "./Reveal";

export default function HighlightsBar() {
  return (
    <section data-testid="highlights-bar" className="bg-brand-bg border-b border-brand-border">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12 lg:px-20">
        <div className="grid grid-cols-2 gap-px bg-brand-border md:grid-cols-4">
          {property.highlights.map((h, i) => (
            <Reveal
              key={h.label}
              testId={`highlight-${i}`}
              delay={i * 0.07}
              y={18}
              amount={0.4}
              className="group flex flex-col gap-2 bg-brand-bg px-6 py-8 transition-colors hover:bg-brand-surface md:px-10 md:py-12"
            >
              <span className="overline">{h.label}</span>
              <span className="font-serif text-3xl text-brand-ink md:text-5xl">
                {h.value}
              </span>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
